/**
 * Form field configurations for Store Handler
 */

export const STORE_HANDLER_FORM_FIELDS = [
    {
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "Name",
        id: "horizontal-name-Input",
        required: false
    },
    {
        name: "handle",
        label: "Coupert Links",
        type: "textarea",
        placeholder: "Write coupert links with comma separator",
        id: "horizontal-handle-Input",
        rows: 5,
        required: false
    },
    {
        name: "hotdeals_handle",
        label: "Hotdeals Links",
        type: "textarea",
        placeholder: "Write hotdeals links with comma separator",
        id: "horizontal-hotdeals-Input",
        rows: 5,
        required: false
    },
    {
        name: "domain",
        label: "Domain URL",
        type: "text",
        placeholder: "Domain",
        id: "horizontal-domain-Input",
        required: false
    },
    {
        name: "store",
        label: "myShopify URL",
        type: "text",
        placeholder: "Store",
        id: "horizontal-store-Input",
        required: true,
        readOnly: false // Can be overridden in edit mode
    },
    {
        name: "is_active",
        label: "Auto BCL",
        type: "checkbox",
        placeholder: "Auto BCL",
        id: "horizontal-is_active-Input",
        required: false
    }
];

